import {
  SIM_FILTERS_INITIAL_VALUES,
  SIM_FILTERS_INITIAL_VALUES_WITHOUT_CUSTOM_FIELDS,
} from 'atoms/filters/sim';
import { pick } from 'lodash';
import { parseSessionStatus } from './filterParsers.utils';
import {
  addDropdownValueToCustomFieldFilter,
  addTextValueToCustomFieldFilter,
  parseCustomFieldStringToSearchBody,
} from 'common/components/Filters/CustomFieldsFilter/customFields.utils';
import { MNO_STATUS_FILTER, MNOStatus } from 'src/common/components/Sim/constants/mnoStatus';
import { parseSubscriptionStatus } from 'src/common/components/SubscriptionStatus/constants/subscriptionStatus';

export const mapCustomFieldsToURL = (customFields: Record<string, string | string[]>) => {
  const parsedCF = Object.entries(customFields).reduce(
    (customFieldsString: string, [id, value]) => {
      if (Array.isArray(value)) {
        return addDropdownValueToCustomFieldFilter(customFieldsString, id, value);
      } else {
        return addTextValueToCustomFieldFilter(customFieldsString, id, value);
      }
    },
    '',
  );

  return parsedCF;
};

export const mapURLSearchParamsToSimFilters = (urlSearchParams: URLSearchParams) => {
  const filters = Object.fromEntries(urlSearchParams);

  const {
    tags,
    accounts,
    productCodes,
    mobileNetworkOperator,
    mnoStatus,
    mnoNames,
    sessionStatus,
    customFields,
    subscriptionStatus,
    ...cleanedFiltersValues
  } = pick(filters, Object.keys(SIM_FILTERS_INITIAL_VALUES));

  let parsedCustomFields = {};
  if (customFields) {
    const parsedCustomFieldsArray = parseCustomFieldStringToSearchBody(customFields);
    parsedCustomFields = parsedCustomFieldsArray.reduce((customFields, customField) => {
      if (customField.textValue) {
        return { ...customFields, [customField.id]: customField.textValue };
      } else if (customField.selectionOptionIds) {
        return { ...customFields, [customField.id]: customField.selectionOptionIds };
      }

      return customFields;
    }, {} as Record<string, string | string[]>);
  }

  return {
    ...SIM_FILTERS_INITIAL_VALUES_WITHOUT_CUSTOM_FIELDS,
    ...cleanedFiltersValues,
    sessionStatus: parseSessionStatus(sessionStatus),
    tags: tags ? tags.split(',') : SIM_FILTERS_INITIAL_VALUES_WITHOUT_CUSTOM_FIELDS.tags,
    subscriptionStatus: subscriptionStatus
      ? subscriptionStatus
          .split(',')
          .map((subscriptionStatus) => parseSubscriptionStatus(subscriptionStatus))
      : SIM_FILTERS_INITIAL_VALUES_WITHOUT_CUSTOM_FIELDS.subscriptionStatus,
    accounts: accounts
      ? accounts.split(',').map((account) => (account === 'null' ? null : account))
      : SIM_FILTERS_INITIAL_VALUES_WITHOUT_CUSTOM_FIELDS.accounts,
    productCodes: productCodes
      ? productCodes.split(',').map((productCode) => (productCode === 'null' ? null : productCode))
      : SIM_FILTERS_INITIAL_VALUES_WITHOUT_CUSTOM_FIELDS.productCodes,
    mobileNetworkOperator: mobileNetworkOperator
      ? mobileNetworkOperator.split(',').map((operator) => (operator === 'null' ? null : operator))
      : SIM_FILTERS_INITIAL_VALUES_WITHOUT_CUSTOM_FIELDS.mobileNetworkOperator,
    mnoNames: mnoNames
      ? mnoNames.split(',')
      : SIM_FILTERS_INITIAL_VALUES_WITHOUT_CUSTOM_FIELDS.mnoNames,
    mnoStatus: mnoStatus
      ? (mnoStatus
          .split(',')
          .map((value) =>
            Number.isNaN(Number.parseInt(value)) ? MNO_STATUS_FILTER.BLANK : Number.parseInt(value),
          ) as MNOStatus[])
      : SIM_FILTERS_INITIAL_VALUES_WITHOUT_CUSTOM_FIELDS.mnoStatus,
    customFields: parsedCustomFields,
  };
};
